import React from "react";
import { Link } from "react-router-dom";
import Icon from "../components/Icon";

export default function AcademyPage() {
  return (
    <>
      <header className="relative overflow-hidden pt-16 pb-20 md:pt-32 md:pb-48 bg-surface-bright">
        <div className="relative z-10 max-w-max-width mx-auto page-x text-center">
          <div className="inline-block px-4 py-1.5 mb-6 rounded-full bg-primary-fixed text-on-primary-fixed font-label-md text-label-md">
            Celestial Islamic Education
          </div>
          <h1 className="text-display-responsive text-primary mb-6 max-w-3xl mx-auto">
            About Online Quran Universe
          </h1>
          <p className="font-body-lg text-body-lg text-on-surface-variant max-w-2xl mx-auto">
            We bridge the gap between tradition and technology, focusing on live
            teacher-led classes that provide personalized spiritual growth and
            academic excellence from the comfort of your home.
          </p>
        </div>
        <div className="absolute bottom-0 left-0 w-full h-24 bg-gradient-to-t from-background to-transparent" />
      </header>

      <section className="section-y bg-background relative">
        <div className="max-w-max-width mx-auto page-x grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-16 items-center">
          <div className="relative rounded-2xl overflow-hidden shadow-xl aspect-square border-4 border-surface-container-highest">
            <img
              alt="Our Purpose"
              className="w-full h-full object-cover"
              src="https://lh3.googleusercontent.com/aida-public/AB6AXuDst3RHgpZmXnklUGvavZ2R2dPZGqy37UOV7CJ57PQCsAv_5xBgBWi4p-19I0HTZHM2y50-p8DcMGNjs7qaM5gqH5y27nWBzL2-3MTtMXHiFfdAr76M70stjhSZIM6WRUkZwyqNlewqHVfvNqEHigMFta5EO9cZC25rj1IV6xltiLLnps--1yksg2ZEXXWvnhzF4Qo-nzL60YVnRSWIgHHemQJNOS2ft9L-mxOfKqSIM6yn3_TwTrh2tRtFlrt_pHz-yEResRZt2W59"
            />
          </div>
          <div>
            <h2 className="text-headline-responsive text-primary mb-8">
              Our Purpose
            </h2>
            <div className="space-y-6 text-on-surface-variant">
              <p className="font-body-lg text-body-lg">
                At Online Quran Universe, we believe that the beauty of the
                Quran should be accessible to every heart, regardless of
                geographical boundaries or busy schedules. Our mission is to
                democratize high-quality Islamic education.
              </p>
              <p className="font-body-lg text-body-lg">
                We have meticulously curated a global network of certified
                teachers who bring both expertise and empathy to the virtual
                classroom. Our goal is to make learning the Quran an enlightened
                journey of discovery rather than just a curriculum to be
                completed.
              </p>
              <div className="flex gap-4 items-center pt-4">
                <div className="w-12 h-12 rounded-full bg-tertiary-fixed flex items-center justify-center">
                  <Icon
                    name="star"
                    className="material-symbols-outlined text-on-tertiary-fixed"
                  />
                </div>
                <div>
                  <p className="font-label-md text-label-md text-primary font-bold">
                    100,000+ Minutes
                  </p>
                  <p className="font-caption text-caption">
                    Of learning delivered monthly
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section-y bg-surface-container-low geometric-pattern">
        <div className="max-w-max-width mx-auto page-x">
          <div className="text-center mb-10 md:mb-16">
            <h2 className="text-headline-responsive text-primary">
              What Makes Us Different
            </h2>
            <p className="font-body-md text-body-md text-on-surface-variant mt-4">
              Pioneering a new standard in celestial-focused learning.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-surface-container-lowest card-pad rounded-2xl border border-outline-variant shadow-sm hover:shadow-lg transition-all group">
              <div className="w-14 h-14 bg-primary-fixed rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <Icon
                  name="public"
                  className="material-symbols-outlined text-primary text-3xl"
                />
              </div>
              <h3 className="font-headline-md text-headline-md text-primary mb-3">
                Global Access
              </h3>
              <p className="text-on-surface-variant">
                Learn from anywhere in the world with our cloud-optimized
                classroom environment.
              </p>
            </div>

            <div className="bg-surface-container-lowest card-pad rounded-2xl border border-outline-variant shadow-sm hover:shadow-lg transition-all group">
              <div className="w-14 h-14 bg-primary-fixed rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <Icon
                  name="sentiment_very_satisfied"
                  className="material-symbols-outlined text-primary text-3xl"
                />
              </div>
              <h3 className="font-headline-md text-headline-md text-primary mb-3">
                Friendly Teachers
              </h3>
              <p className="text-on-surface-variant">
                Our instructors are hand-picked for their patience and ability
                to connect with students of all ages.
              </p>
            </div>

            <div className="bg-surface-container-lowest card-pad rounded-2xl border border-outline-variant shadow-sm hover:shadow-lg transition-all group">
              <div className="w-14 h-14 bg-primary-fixed rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <Icon
                  name="schedule"
                  className="material-symbols-outlined text-primary text-3xl"
                />
              </div>
              <h3 className="font-headline-md text-headline-md text-primary mb-3">
                Flexible Timing
              </h3>
              <p className="text-on-surface-variant">
                Choose slots that fit your lifestyle. We operate 24/7 to
                accommodate all time zones.
              </p>
            </div>

            <div className="bg-surface-container-lowest card-pad rounded-2xl border border-outline-variant shadow-sm hover:shadow-lg transition-all group">
              <div className="w-14 h-14 bg-primary-fixed rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <Icon
                  name="auto_awesome"
                  className="material-symbols-outlined text-primary text-3xl"
                />
              </div>
              <h3 className="font-headline-md text-headline-md text-primary mb-3">
                Certified Quality
              </h3>
              <p className="text-on-surface-variant">
                All teachers undergo a 3-step verification process and hold
                Ijazah certificates.
              </p>
            </div>

            <div className="bg-surface-container-lowest card-pad rounded-2xl border border-outline-variant shadow-sm hover:shadow-lg transition-all group">
              <div className="w-14 h-14 bg-primary-fixed rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <Icon
                  name="family_restroom"
                  className="material-symbols-outlined text-primary text-3xl"
                />
              </div>
              <h3 className="font-headline-md text-headline-md text-primary mb-3">
                Family Plans
              </h3>
              <p className="text-on-surface-variant">
                Manage multiple children from one dashboard with significant
                multi-student discounts.
              </p>
            </div>

            <div className="bg-surface-container-lowest card-pad rounded-2xl border border-outline-variant shadow-sm hover:shadow-lg transition-all group">
              <div className="w-14 h-14 bg-primary-fixed rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <Icon
                  name="analytics"
                  className="material-symbols-outlined text-primary text-3xl"
                />
              </div>
              <h3 className="font-headline-md text-headline-md text-primary mb-3">
                Visual Reporting
              </h3>
              <p className="text-on-surface-variant">
                Detailed monthly progress reports visualizing your journey
                through the celestial levels.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="section-y bg-background">
        <div className="max-w-max-width mx-auto page-x">
          <div className="text-center mb-10 md:mb-20">
            <h2 className="text-headline-responsive text-primary">
              Our Teaching Approach
            </h2>
            <p className="font-body-md text-body-md text-on-surface-variant mt-4">
              A structured path to spiritual and linguistic mastery.
            </p>
          </div>
          <div className="relative grid grid-cols-1 md:grid-cols-3 lg:grid-cols-6 gap-8">
            <div className="flex flex-col items-center text-center relative group">
              <div className="w-20 h-20 rounded-full bg-white border-4 border-primary-fixed flex items-center justify-center mb-4 z-10 group-hover:bg-primary-fixed transition-colors">
                <span className="font-headline-md text-headline-md text-primary font-bold">
                  01
                </span>
              </div>
              <h4 className="font-label-md text-label-md text-primary font-bold mb-2">
                Assess
              </h4>
              <p className="text-caption text-caption text-on-surface-variant">
                Evaluate current level and goals.
              </p>
            </div>

            <div className="flex flex-col items-center text-center relative group">
              <div className="w-20 h-20 rounded-full bg-white border-4 border-primary-fixed flex items-center justify-center mb-4 z-10 group-hover:bg-primary-fixed transition-colors">
                <span className="font-headline-md text-headline-md text-primary font-bold">
                  02
                </span>
              </div>
              <h4 className="font-label-md text-label-md text-primary font-bold mb-2">
                Recommend
              </h4>
              <p className="text-caption text-caption text-on-surface-variant">
                Custom curriculum selection.
              </p>
            </div>

            <div className="flex flex-col items-center text-center relative group">
              <div className="w-20 h-20 rounded-full bg-white border-4 border-primary-fixed flex items-center justify-center mb-4 z-10 group-hover:bg-primary-fixed transition-colors">
                <span className="font-headline-md text-headline-md text-primary font-bold">
                  03
                </span>
              </div>
              <h4 className="font-label-md text-label-md text-primary font-bold mb-2">
                Start
              </h4>
              <p className="text-caption text-caption text-on-surface-variant">
                Free trial class with a teacher.
              </p>
            </div>

            <div className="flex flex-col items-center text-center relative group">
              <div className="w-20 h-20 rounded-full bg-white border-4 border-primary-fixed flex items-center justify-center mb-4 z-10 group-hover:bg-primary-fixed transition-colors">
                <span className="font-headline-md text-headline-md text-primary font-bold">
                  04
                </span>
              </div>
              <h4 className="font-label-md text-label-md text-primary font-bold mb-2">
                Practice
              </h4>
              <p className="text-caption text-caption text-on-surface-variant">
                Regular interactive sessions.
              </p>
            </div>

            <div className="flex flex-col items-center text-center relative group">
              <div className="w-20 h-20 rounded-full bg-white border-4 border-primary-fixed flex items-center justify-center mb-4 z-10 group-hover:bg-primary-fixed transition-colors">
                <span className="font-headline-md text-headline-md text-primary font-bold">
                  05
                </span>
              </div>
              <h4 className="font-label-md text-label-md text-primary font-bold mb-2">
                Track
              </h4>
              <p className="text-caption text-caption text-on-surface-variant">
                Monitor growth with analytics.
              </p>
            </div>

            <div className="flex flex-col items-center text-center relative group">
              <div className="w-20 h-20 rounded-full bg-white border-4 border-primary-fixed flex items-center justify-center mb-4 z-10 group-hover:bg-primary-fixed transition-colors">
                <span className="font-headline-md text-headline-md text-primary font-bold">
                  06
                </span>
              </div>
              <h4 className="font-label-md text-label-md text-primary font-bold mb-2">
                Improve
              </h4>
              <p className="text-caption text-caption text-on-surface-variant">
                Refine and advance skills.
              </p>
            </div>

            <div className="hidden lg:block absolute top-10 left-10 right-10 h-0.5 border-t-2 border-dashed border-outline-variant -z-0"></div>
          </div>
        </div>
      </section>

      <section className="section-y bg-primary-container text-on-primary-container relative overflow-hidden">
        <div className="relative z-10 max-w-max-width mx-auto page-x flex flex-col items-center text-center">
          <h2 className="text-display-responsive mb-6">
            Ready to Begin Your Journey?
          </h2>
          <p className="font-body-lg text-body-lg mb-10 max-w-2xl text-primary-fixed-dim">
            Start with a Free Trial Class. No credit card required. Experience
            the personalized attention that makes Online Quran Universe unique.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <Link
              to="/contact"
              className="bg-tertiary-fixed text-on-tertiary-fixed px-10 py-4 rounded-full font-bold text-lg hover:scale-105 transition-all shadow-lg text-center"
            >
              Book Free Trial
            </Link>
            <Link
              to="/programs"
              className="bg-transparent border-2 border-on-primary-container text-on-primary-container px-10 py-4 rounded-full font-bold text-lg hover:bg-on-primary-container hover:text-primary-container transition-all text-center"
            >
              View Programs
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
